export default __webpack_public_path__ + "static/media/external-link.6a233fa4.svg";